import React from 'react';
import { useModal } from './hooks';
import { Modal } from './Modal';
import { Icon } from '@apia/icons';
import { Box, getVariant, Link } from '@apia/theme';

export const DeadSessionModal = ({ onClick }: { onClick: () => unknown }) => {
  const { Portal } = useModal();
  return (
    <Modal
      Portal={Portal}
      isOpen
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      hideCloseButton
      sx={React.useMemo(
        () => ({
          backgroundColor: 'palette.background.default',
        }),
        [],
      )}
    >
      <Box
        role="alert"
        {...getVariant('layout.common.modals.deadSession')}
        className="deadSession"
      >
        <Box className="textAndIcon">
          <Icon title="" size="iconLg" name="Alert" />
          {window.MSG_INVALID_SESSION}
        </Box>
        <Link
          className="goHomeLink"
          href={window.CONTEXT}
          onClick={React.useCallback(
            (ev: React.MouseEvent) => {
              ev.preventDefault();
              onClick();
            },
            [onClick],
          )}
        >
          {window.LBL_GOTO_LOGIN}
        </Link>
      </Box>
    </Modal>
  );
};
